import React from "react";
import styled from "styled-components";
import Switch from "react-switch";

const S = styled(Switch)`
  vertical-align: middle;
  margin-left: 25px;
`;

export const StyledSwitch = ({ active, toggleActive }) => (
  <S
    name="active"
    checked={active || false}
    onChange={(checked) => {
      toggleActive(checked);
    }}
  />
);
